module.exports = __webpack_public_path__ + "img/Lesson.768f1ff1.svg";